module.exports = __webpack_public_path__ + "static/media/150.648e3cc2.svg";